const DUMMY = {
	MOOD_IMAGES: [1, 2, 3, 4, 5],
	ENTRIES: [
		{
			title: "No Way Home movie!",
			key: "No Way Home movie!",
			date: "Thurs, Jan 12, 2022 4:32pm",
			tags: "• Food • Friends • Movies • Relaxed • Excited",
			mood: 3,
			content: "Today I went to see No Way Home! It was an awesome movie and everyone was cheering in the audience when Toby Maguire appeared. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vel vehicula nisi. Donec et leo elit. Fusce feugiat augue iaculis purus egestas ultrices. Integer ultrices metus eget arcu vulputate commodo. Nullam et tincidunt risus, vitae pulvinar nulla. Cras placerat egestas lobortis. Proin dictum ante sem, et aliquet ex lacinia sit amet. Praesent in ex lacus.Pellentesque at metus est.\n\nSuspendisse bibendum, nisl ut commodo molestie, est magna auctor nibh, id efficitur metus lectus volutpat orci. Nulla eleifend at metus at faucibus. Suspendisse vestibulum laoreet tortor, id vehicula lectus facilisis id. Aenean urna diam, ornare nec diam ut, molestie volutpat felis. Etiam ac luctus ex. Pellentesque semper libero et augue congue, vitae pellentesque diam iaculis. Donec sit amet urna vitae nisl sollicitudin auctor id eget tellus. Vivamus pellentesque fermentum consequat. Integer rhoncus diam nec orci sagittis, in rutrum mauris ornare. Nullam risus elit, feugiat a ullamcorper at, placerat vel felis. Vivamus mollis accumsan magna non cursus."
		},
		{
			title: "Homework day",
			key: "Homework day",
			date: "Thurs, Jan 10, 2022 1:25pm",
			tags: "• Homework • Stressed",
			mood: 1,
			content: "Homework day I had so much homework it took me the whole day to finish. I also have finals coming up and need to review the lectures for the entire last 5 weeks. My group also barely does any work on the project."
		}
	]
}


export default DUMMY